<template>
    <div class="header__design">
      <div>
        <div style="position:relative">
          <img src="./../../assets/left-pool.svg" alt="Small pool" class="small-pool-left">
        </div>
        <div v-if="image == 'ts'" style="position:relative">
          <img src="./../../assets/tearmsandconditions.svg" alt="" class="paddingImage">          
        </div>
        <div v-else-if="image == 'pp'" style="position:relative">
          <img src="./../../assets/privacyandpolicy.svg" alt="" class="small-pool-right" style="top: -11px;">          
        </div>
        <div v-else-if="image == 'cu'" style="position:relative" >
          <img src="./../../assets/contactus.svg" alt="" class="paddingImage">          
        </div>
        <div v-else-if="image == 'asu'" style="position:relative">
          <img src="./../../assets/advertisersingup.svg" alt="" class="paddingImage">          
        </div>
        <div v-else style="position:relative">
          <img src="./../../assets/right-pool.svg" alt="Small pool" class="small-pool-right">
          <img src="./../../assets/car.svg" alt="Car" class="car-right">
        </div>
      </div>
      <router-link id="header-home" to="/"></router-link>
      <div class="side-page-header" @click="click">
        <img src="./../../assets/header.png" alt="Adway name">
      </div>
      <!-- <img src="./../../assets/car.svg" alt="Car" class="car-right"> -->
    </div>
</template>

<script>
import tearmsAndConditions from './../../assets/tearmsandconditions.svg'
import privacyAndPolicy from './../../assets/privacyandpolicy.svg'
import contactUs from './../../assets/contactus.svg'
import advertiserSingUp from './../../assets/advertisersingup.svg'
export default {
  name: 'PageHeader',
  data: function () {
    return {
      pickerImage: '',
      driver: null,
      imageTag: ''
    }
  },
  props: {
    image: String
  },
  methods: {
    setImage () {
      this.imageTag = this.image
      switch (this.image) {
        case 'ts' :
          this.pickerImage = tearmsAndConditions
          this.driver = false
          break
        case 'pp' :
          this.pickerImage = privacyAndPolicy
          this.driver = false
          break
        case 'cu' :
          this.pickerImage = contactUs
          this.driver = false
          break
        case 'asu' :
          this.pickerImage = advertiserSingUp
          this.driver = false
          break
        default:
          this.driver = true
      }
    },
    click () {
      document.getElementById('header-home').click()
    }
  },
  created: function () {
    this.setImage()
  }
}
</script>
